import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const SecondaryAction = ({ label , onClick  })=>/*#__PURE__*/ React.createElement(Button, {
        type: "button",
        "data-t": "nav-button",
        variant: "outline",
        caption: label,
        size: "medium",
        className: "configurator-footer-nav",
        onClick: onClick
    })
;

export { SecondaryAction };
//# sourceMappingURL=SecondaryAction.js.map
